import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
// import Updatepostmoda from '../../Modal/Updatepostmoda'
import { useDispatch, useSelector } from 'react-redux';
import BusinessPostModal from '../../Modal/BusinessPostModal';
// import { fetchAllBusinessPosts } from '../../Redux/Slice/BusinessPostSlice';

const Blmpostadd = ({ postCount }) => {
    const { UserProfileID } = useSelector((state) => state.app);
    const { AllBusinessPosts } = useSelector((state) => state.post)
    const [othersPostUpdates, setOthersPostUpdates] = useState()

    useEffect(() => {
        setOthersPostUpdates(AllBusinessPosts.filter(item => item.userData._id !== UserProfileID?._id)?.length)
    }, [AllBusinessPosts])

    const [ownpostupdatemodal, setownpostupdatemodal] = useState(false)
    const ownnsposyymodal = () => {
        setownpostupdatemodal(!ownpostupdatemodal)
    }

    return (
        <>
            <div className='bmlmmaposttaddddib'>
                <div className='bmlmmaposttaddddibdivmain'>
                    <p className='poiosyyattatxtpp'>
                        Post your latest product or service to connect your customers.
                    </p>
                    <div className='poisyybtnmainlibkldivflx'>
                        <button
                            className='poisyybtnmain'
                            onClick={ownnsposyymodal}
                            disabled={!UserProfileID?.businessStatus}
                        >
                            Post
                            <i className="fa-solid fa-plus"></i>
                        </button>
                        <div className=''>
                            {
                                UserProfileID?.businessStatus ? (
                                    <Link to="/ownpostpage" className="viewallpostlnk">View Update ({othersPostUpdates || 0})</Link>
                                ) : (
                                    <p className="viewallpostlnk" style={{ color: "#b0beb9", cursor: "not-allowed" }}>View Update</p>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>
            {/* {ownpostupdatemodal && <Updatepostmoda closemodal={setownpostupdatemodal} />} */}
            {ownpostupdatemodal && <BusinessPostModal closemodal={setownpostupdatemodal} />}
        </>
    )
}

export default Blmpostadd
